import get from 'lodash/get';

function getConfigurationList(state) {
  return get(state, ['paymentConfiguration', 'configurationList'], []);
}

export default getConfigurationList;
